import { CookieStoreService } from './../../modules/shared/services/cookie-store.service';
import { AppMainService } from './../../app-main.service';
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { ProfileService } from "../profileService";
import { UserPreference } from "src/app/modules/shared/models/user-preference/user-preference.model";
import { Subject, takeUntil } from "rxjs";
import { MessageService } from "primeng/api";
import { USERPREFERENCEMODULES } from 'src/app/modules/shared/constants/user-preference.constant';
import { PermissionService } from 'src/app/service/permission.service';

@Component({
    selector: "app-user-preference",
    templateUrl: "./user-preference.component.html",
    styleUrls: ["./user-preference.component.scss"],
})
export class UserPreferenceComponent implements OnInit, OnDestroy {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @Input() showSetting: boolean = true;
    flatLayouts: any[];
    specialLayouts: any[];
    defaultModuleList: any[];
    themes: any[];
    layout = "blue";
    userPreferences: UserPreference;
    currentUser;
    selectedModulePath: string = "/";
    encryptSecretKey = "LionO3602.0CRM2021";
    moduleNames = USERPREFERENCEMODULES;
    permittedModuleNames: any[] = [];

    constructor(
        private cookieStoreService: CookieStoreService,
        public app: AppMainComponent,
        public profileService: ProfileService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private permissionService: PermissionService
    ) { }

    ngOnInit() {

        this.defaultModuleList = [
            { moduleName: 'Stream', modulePath: '/' },
            { moduleName: 'Dashboard', modulePath: '/dashboard' }];

        this.flatLayouts = [
            { name: "dark", color: "#3b3b48" },
            { name: "turquoise", color: "#04838f" },
            { name: "green", color: "#1e8455" },
            { name: "blue", color: "#2461cc" },
            { name: "rose", color: "#79425a" },
            { name: "teal", color: "#427976" },
            { name: "bluegrey", color: "#37474f" },
            { name: "purple", color: "#5d4279" },
        ];

        this.specialLayouts = [
            { name: "cosmic", color1: "#517fa4", color2: "#243949" },
            { name: "lawrencium", color1: "#302b63", color2: "#201B4C" },
            { name: "couple", color1: "#3a6186", color2: "#89253e" },
            { name: "stellar", color1: "#7474BF", color2: "#348AC7" },
            { name: "beach", color1: "#00cdac", color2: "#02aab0" },
            { name: "flow", color1: "#136a8a", color2: "#267871" },
            // {name: 'fly', color1: '#7b4397', color2: '#b22f64'},
            { name: "nepal", color1: "#614385", color2: "#516395" },
            { name: "celestial", color1: "#734b6d", color2: "#734b6d" },
        ];

        this.themes = [
            { name: "red", color: "#ce1800" },
            { name: "green", color: "#9fd037" },
            { name: "teal", color: "#12b886" },
            { name: "blue", color: "#3ebaf8" },
            { name: "amber", color: "#f7cb00" },
            { name: "purple", color: "#966af1" },
            { name: "turquoise", color: "#2ab1be" },
            { name: "bluegrey", color: "#546E7A" },
            { name: "purple2", color: "#5B548E" },
        ];

        this.isCookiePresentOnNot();
        this.userModuleList();
    }

    changeTheme(theme) {
        this.app.currentUser.theme = theme;
        const themeLink: HTMLLinkElement = document.getElementById(
            "theme-css"
        ) as HTMLLinkElement;
        const href = "assets/theme/theme-" + theme + ".css";

        this.replaceLink(themeLink, href);
        // this.app.updateUser(this.app.currentUser);
    }
    changeLayout(layout) {
        this.app.currentUser.layout = layout;
        const layoutLink: HTMLLinkElement = document.getElementById(
            "layout-css"
        ) as HTMLLinkElement;
        const href = "assets/layout/css/layout-" + layout + ".css";

        this.replaceLink(layoutLink, href);
        // this.app.updateUser(this.app.currentUser);
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    replaceLink(linkElement, href) {
        if (this.isIE()) {
            linkElement.setAttribute("href", href);
        } else {
            const id = linkElement.getAttribute("id");
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute("href", href);
            cloneLinkElement.setAttribute("id", id + "-clone");

            linkElement.parentNode.insertBefore(
                cloneLinkElement,
                linkElement.nextSibling
            );

            cloneLinkElement.addEventListener("load", () => {
                linkElement.remove();
                cloneLinkElement.setAttribute("id", id);
            });
        }
    }

    onConfigButtonClick(event) {
        this.app.configActive = !this.app.configActive;
        this.app.configClick = true;
    }

    getAllUserPreference() {
        this.profileService.getUserPreference().subscribe((preference: any) => {
            this.reloadPreference(preference);
        });
    }

    saveSettings() {
        const savedUserPreference: UserPreference = {
            menuMode: this.app.currentUser.menuMode,
            inputStyle: this.app.currentUser.inputStyle,
            ripple: this.app.currentUser.ripple,
            layoutColor: null,
            layout: this.app.currentUser.layout,
            theme: this.app.currentUser.theme,
            landingPage: this.selectedModulePath || "/",
        }
        this.appMainService.isShowSpinner('savedUserPrefernce');
        this.profileService.saveUserPreference(savedUserPreference).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (preference) => {
                this.reloadPreference(preference);
                this.appMainService.isHideSpinner('savedUserPrefernce');
                this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'User preference updated successfully.' });
            },
            error: (error) => {
                this.appMainService.isHideSpinner('savedUserPrefernce');
                this.messageService.add({ severity: 'error', summary: 'Update Failed', detail: 'Failed to update user preference, please try again.' });
            }
        });

    }

    resetSettings() {
        this.profileService.resetUserPreference().subscribe(preference => {
            this.reloadPreference(preference);
        })
    }

    isCookiePresentOnNot() {
        const cookieAccepted = this.cookieStoreService.isCookieAccepted();
        const preference = this.cookieStoreService.getUserPreferanceCookie();
        if (cookieAccepted && preference) {
            this.reloadPreference(preference);
        } else {
            this.getAllUserPreference();
        }
    }

    reloadPreference(preference: any) {
        if (preference) {
            let cookieAccepted = this.cookieStoreService.isCookieAccepted();
            if (cookieAccepted) {
                this.cookieStoreService.setUserPreferenceCookie(preference);
            }

            this.app.currentUser = {
                ...this.app.currentUser,
                ...preference,
            };
            this.selectedModulePath = preference?.landingPage || '/';
            this.changeTheme(this.app.currentUser.theme);
            this.changeLayout(this.app.currentUser.layout);
        }
    }

    userModuleList() {
        const userPermissions = this.permissionService.getPermissionData();
        this.permittedModuleNames = [];
        this.moduleNames.forEach((obj) => {
            if (userPermissions.find((filterObj) => filterObj.objectName === obj.objectName && filterObj.permissions.find(obj => obj.statusId == 1))) {
                
                this.permittedModuleNames.push(obj);
            }
        });
        this.permittedModuleNames = [...this.defaultModuleList, ...this.permittedModuleNames];
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
